import state from './moduleDispenseRequestState.js';
import mutations from './moduleDispenseRequestMutations.js';
import actions from './moduleDispenseRequestActions.js';
import getters from './moduleDispenseRequestGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
